import { Navigate } from "react-router-dom";
import { routes } from "../helpers/constants";
import LoginPage from "../pages/Login/LoginPage";
import Dashboard from "../pages/Dashboard";
import BranchCreation from "../pages/Creation/BranchCreation";

export const authRoutes = [
  { path: routes.homepage, element: <Navigate to={routes.login} /> },
  { path: routes.login, element: <LoginPage /> },
];

export const adminRoutes = [
  { path: routes.homepage, element: <Navigate to={routes.dashboard} /> },
  { path: routes.dashboard, element: <Dashboard /> },
  { path: routes.creation, element: <BranchCreation /> },
];

export const invalidRoutes = [
  { path: "*", element: <LoginPage /> },
  { path: routes.login, element: <LoginPage /> },
];
